import { memo } from "react";
import TournamentEndJackpot from "./Jackpot";
import TournamentEndRegular from "./Regular";
import { useSelector } from "react-redux";
import { getSkinId } from "../../../store/selectors";

const TournamentEnd = (props) => {
  const { payload } = props;
  const skinId = useSelector(getSkinId);
  const isSpinAndGo = payload?.tournamentType === "spinAndGo";

  const shouldRenderComponent = isSpinAndGo || (!isSpinAndGo && !['678544', '192347'].includes(skinId));

  if (!shouldRenderComponent) return null;

  const Component = isSpinAndGo ? TournamentEndJackpot : TournamentEndRegular;

  return <Component {...props} />;
};

export default memo(TournamentEnd);
